import { React } from "react";
import { Col, Row } from "reactstrap";
import { imageURl, GenaiUrl, CreateQuizUrl, QuizyUrl,TempUrl } from "../../libs/env";
import { AccountType, exerciseType } from "../constants/constants";
import EditButton from "../../components/buttons/EditButton";
import { handleHeaderInput } from "../edit_quiz_helper/EditQuizHelper.jsx";
import { useLocation } from "react-router-dom";
export function QuestionHeading({
  data,
  datatype,
  visualizerToggle,
  setContentedit,
  Contentedit,
  onUpdate,
  focusblink,
  blurblink,
  isBlinking,
  setIsBlinking
}) {
  const {pathname} = useLocation()
  let fsize = "fs-6";
  let img_size = "30px";
  let p_size = "py-2";
  let params = new URL(document.location).searchParams;
  let edit_template = params.get("edit_template");
  let quizy_template = params.get("quizy_template");
 if(edit_template === "true" || pathname?.includes(TempUrl))
 {
    // fsize = "preview_fsize";
    // img_size = "16px";
    // p_size = "py-0";
    fsize = "fs-6";
    img_size = "30px";
    p_size = "py-2";
 }
  return (
    <>
      {pathname?.includes(GenaiUrl) ||
      pathname?.includes(CreateQuizUrl) ? (
        <Row>
          <Col md className={`${p_size} col-12 d-flex align-items-center`}>
            <div
            onFocus={focusblink}
            onBlur={blurblink}
            spellcheck="false"
            data-gramm="false"
              class="col-10 d-flex justify-content-start"
              contentEditable={Contentedit}
              onInput={handleHeaderInput({
                type: "header",
                quizdata: data,
              })}
            >
              {pathname?.includes(CreateQuizUrl) ?
              (<h1 class="fs-6 fw-bold mb-0 pe-3">
                {data?.prompt_content?.content}
                {data?.prompt_content?.isMounted ? (
                  ""
                  ) : (
                  <span className="blinking-cursor"></span>
                )}
              </h1>):
              (
                <h1 class={`${fsize} fw-bold mb-0 pe-3`}>
                  {data.prompt_content}
                  { isBlinking &&(<span className="blink-icon ms-2"></span>)}
                </h1>
              )}
            </div>
            <div class="col-2 d-flex justify-content-end">
              {Contentedit ? (
                <EditButton
                  label="Save"
                  onClick={() => {
                    setContentedit(false);
                    onUpdate(data);
                    setIsBlinking(false);
                  }}
                />
              ) : (
                <EditButton
                  label="Edit"
                  onClick={() => {
                    setContentedit(true);
                    setIsBlinking(true);
                  }}
                />
              )}
            </div>
          </Col>
        </Row>
      ) : window.location.origin.includes(QuizyUrl) || quizy_template === "true" ? (
        <>
          {data && data?.board_logo === null && data?.task_board === null ? (
            <Row>
              <Col
                md
                className={`${p_size} col-lg-12 col-sm-12 col-md-12 d-flex align-items-center`}
              >
                <div
                  class={
                    "col-12 d-flex justify-content-start"
                  }
                >
                  <h1 class={`${fsize} fw-bold mb-0`}>
                    {" "}
                    {data.prompt_content}{" "}
                  </h1>
                </div>
              </Col>
            </Row>
          ) : (
            <Row>
              <Col
                md
                className={ `${p_size} d-flex align-items-center`}
              >
                <h1 class={`${fsize} fw-bold mb-0`}> {data.prompt_content} </h1>
              </Col>
              <Col
                md
                className={`pub-logo ${p_size} d-flex align-items-center justify-content-end`}
              >
                {data && data.task_board !== null ? (
                  <>
                    <div class="col-6 sm-display justify-content-start">
                      <img
                        src={data.board_logo}
                        height={`${img_size}`}
                        alt=""
                      />
                      <span className="ms-2 fw-bold text-center">
                        {data.task_board}
                      </span>
                    </div>
                    <div class="lg-display me-2">
                      <img
                        src={data.board_logo}
                        height={`${img_size}`}
                        alt=""
                      />
                      <span className="ms-2 fw-bold text-center">
                        {data.task_board}
                      </span>
                    </div>
                  </>
                ) : null}
              </Col>
            </Row>
          )}
          <p className="quiz-bottom-border pt-1"></p>
        </>
      ) : data && (datatype === "Assessment") ? (
        <Row className="g-0">
          <Col md className="py-2 col-12 d-flex align-items-center">
            <div class="col-lg-12 col-sm-12 col-md-12 d-flex justify-content-start">
              <h1 class="fs-6 fw-bold mb-0 pe-3"> {data.prompt_content} </h1>
            </div>
          </Col>
          <p className="quiz-bottom-border pt-1"></p>
        </Row>
      ) : (
        <>
          {data && data.logo === null && data.pub_name === null ? (
            <Row>
              <Col
                md
                className="py-2 col-lg-12 col-sm-12 col-md-12 d-flex align-items-center"
              >
                <div
                  class={
                    data.task_type === exerciseType.PRONUNCIATION_TASK
                      ? "col-lg-9 col-sm-8 col-md-9 d-flex justify-content-start"
                      : "col-10 d-flex justify-content-start"
                  }
                >
                  <h1 class="fs-6 fw-bold mb-0 pe-3">
                    {" "}
                    {data.prompt_content}{" "}
                  </h1>
                </div>
                {data.user_type !== AccountType.STUDENT ? (
                  <div class="col-2 d-flex justify-content-end">
                    {data.is_premium ? (
                      <>
                        <span className="quiz-ribbon quiz-ribbon-premium px-3 p-1">
                          Premium
                        </span>
                      </>
                    ) : (
                      <>
                        <span className="quiz-ribbon quiz-ribbon-free px-3 p-1">
                          Free
                        </span>
                      </>
                    )}
                  </div>
                ) : null}
                {data.task_type === exerciseType.PRONUNCIATION_TASK ? (
                  <div
                    type="btn"
                    className="col-lg-1 col-sm-2 col-md-1 text-end ps-1"
                    onClick={visualizerToggle}
                  >
                    <img
                      src={`${imageURl}/test-mic.svg`}
                      loading="lazy"
                      height="40px"
                      width="40px"
                      className="exercise-bg-reading p-1 border-50 "
                      alt=""
                    />
                  </div>
                ) : null}
              </Col>
            </Row>
          ) : (
            <Row>
              <Col
                md
                className={
                  data.user_type !== AccountType.STUDENT
                    ? "py-2 d-flex align-items-center col-8"
                    : "py-2 d-flex align-items-center col-lg-9 col-sm-12"
                }
              >
                <h1 class="fs-6 fw-bold mb-0"> {data.prompt_content} </h1>
              </Col>
              <Col
                md
                className="pub-logo py-2 d-flex align-items-center justify-content-end"
              >
                {data && data.logo !== null ? (
                  <>
                    <div class="col-6 sm-display justify-content-start">
                      <img
                        src={data.logo}
                        loading="lazy"
                        height="30px"
                        alt=""
                      />
                      {data && !data.hide_pub_name ? (
                        <span className="ms-2 fw-bold text-center">
                          {data.pub_name}
                        </span>
                      ) : null}
                    </div>
                    <div class="lg-display me-2">
                      <img
                        src={data.logo}
                        loading="lazy"
                        height="30px"
                        alt=""
                      />
                      {data && !data.hide_pub_name ? (
                        <span className="ms-2 fw-bold text-center">
                          {data.pub_name}
                        </span>
                      ) : null}
                    </div>
                  </>
                ) : null}
                {data.is_premium ? (
                  <>
                    <div class="col-6 sm-display justify-content-end">
                      {data.user_type !== AccountType.STUDENT ? (
                        <span className="quiz-ribbon quiz-ribbon-premium ms-2 px-3 p-1">
                          Premium
                        </span>
                      ) : null}
                      {data.task_type === exerciseType.PRONUNCIATION_TASK ? (
                        <div type="btn" onClick={visualizerToggle}>
                          <img
                            src={`${imageURl}/test-mic.svg`}
                            loading="lazy"
                            height="40px"
                            width="40px"
                            className="exercise-bg-reading p-1 border-50 "
                            alt=""
                          />
                        </div>
                      ) : null}
                    </div>
                    <div class="lg-display">
                      {data.user_type !== AccountType.STUDENT ? (
                        <span className="quiz-ribbon quiz-ribbon-premium px-3 p-1">
                          Premium
                        </span>
                      ) : null}
                      {data.task_type === exerciseType.PRONUNCIATION_TASK ? (
                        <div type="btn" onClick={visualizerToggle}>
                          <img
                            src={`${imageURl}/test-mic.svg`}
                            loading="lazy"
                            height="40px"
                            width="40px"
                            className="exercise-bg-reading p-1 border-50 "
                            alt=""
                          />
                        </div>
                      ) : null}
                    </div>
                  </>
                ) : (
                  <>
                    <div class="col-6 sm-display justify-content-end">
                      {data.user_type !== AccountType.STUDENT ? (
                        <span className="quiz-ribbon quiz-ribbon-free ms-2 px-3 p-1">
                          Free
                        </span>
                      ) : null}
                      {data.task_type === exerciseType.PRONUNCIATION_TASK ? (
                        <div type="btn" onClick={visualizerToggle}>
                          <img
                            src={`${imageURl}/test-mic.svg`}
                            loading="lazy"
                            height="40px"
                            width="40px"
                            className="ms-2 exercise-bg-reading p-1 border-50 "
                            alt=""
                          />
                        </div>
                      ) : null}
                    </div>
                    <div class="lg-display">
                      {data.user_type !== AccountType.STUDENT ? (
                        <span className="quiz-ribbon quiz-ribbon-free px-3 p-1">
                          Free
                        </span>
                      ) : null}
                      {data.task_type === exerciseType.PRONUNCIATION_TASK ? (
                        <div type="btn" onClick={visualizerToggle}>
                          <img
                            src={`${imageURl}/test-mic.svg`}
                            loading="lazy"
                            height="40px"
                            width="40px"
                            className="ms-2 exercise-bg-reading p-1 border-50 "
                            alt=""
                          />
                        </div>
                      ) : null}
                    </div>
                  </>
                )}
              </Col>
              {/* {data.task_type === exerciseType.PRONUNCIATION_TASK ? (
                <Col className="text-end">
                  <div type="btn" onClick={visualizerToggle}>
                    <img
                      src={`${imageURl}/test-mic.svg`}
                      height="40px"
                      width="40px"
                      className="exercise-bg-reading p-1 border-50 "
                      alt=""
                    />
                  </div>
                </Col>
              ) : null} */}
            </Row>
          )}
          <p className="quiz-bottom-border pt-1"></p>
        </>
      )}
    </>
  );
}
